import { createStore } from 'vuex';
import PigmentService from 'services/PigmentService';
import getters from './getters';
import actions from './actions';
import mutations from './mutations';
import * as user from '../modules/user';
import * as generic from '../modules/generic';
import * as productComparison from '../modules/product-comparison';

const state = {
  results: {
    total: 0,
    hits: [],
    aggregations: {}
  },
  urlFilters: PigmentService.parseUrlFilters(),
  filterConfig: payload.filterConfig,
  activeDropDownFilter: null,
  isLoading: false,
  fieldManifest: payload.fieldManifest,
  mobileFilterBarVisible: false,
  trackNextSearch: true
};

const store = createStore({
  modules: {
    user,
    generic,
    productComparison
  },
  state,
  getters,
  actions,
  mutations
});

user.init(store);
generic.init(store);

export default store;
